<template>
    <div>
      <hr style="margin: 20px 0px 20px 0px;border-style: ridge;">
      <h3 class="hidden-sm-and-down alignleftTitle">Custom Made Curtains 
         
        </h3>
        <div  class="hidden-md-and-up" @click="addNewCurtain">
        <el-tag type="success" style="font-size:10px"><i class="el-icon-plus"></i></el-tag>
        </div>
        <el-row :gutter="20" class="hidden-sm-and-down alignLeft">
            <el-col :lg="1" :md="1" :offset="2" class="alignCenter">No.</el-col>
            <el-col :lg="3" :md="3">Reference</el-col>
            <el-col :lg="2" :md="2">
                Track Type
                 <el-popover placement="top-start" width="600" trigger="hover">
                      <table cellpadding="8px">
                        <th style="width:80px">Name</th>
                        <th style="width:30px">Price</th>
                        <th style="width:200px">What is It</th>                       
                        <th style="width:50px">Sample Picture</th>                        
                        <tr>
                            <td>Sliding Track (Double Pleat)</td>
                            <td>$9.9/m</td>
                            <td>Pinch pleat curtains are a decorative heading for curtains 
                                 and valances and can be used on all curtain tracks and poles. 
                                 Pinch pleat heading is more gathered than other curtain headings 
                                 with the pleats sewn in to give a luxurious and permanent gathered look.</td>                            
                            <td><a href="https://api.ifurniture.co.nz/image/sliding-curtain-track.jpeg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/sliding-curtain-track.jpeg"></a></td>                                                      
                        </tr>
                        <tr>
                            <td>Eyelet Track (Ring Top)</td>
                            <td>$15/m</td>
                            <td>heading for use with curtain poles. Eyelet heading gives large even soft pleats 
                                 and are so called because they have metal rings at the top of the curtain in place 
                                 of a normal header tape.</td>
                            
                             <td><a href="https://api.ifurniture.co.nz/image/eyelet-curtain-track.jpeg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/eyelet-curtain-track.jpeg"></a></td>                                                      
                        </tr>
                        
                    </table>
                    
                  <div class="el-icon-info" slot="reference" style="color:green"></div>
                 </el-popover>
            </el-col>
              <el-col :lg="2" :md="2">Width(cm)
                 <el-popover placement="top-start" title="About Width" 
               width="400" trigger="hover">
                    <h3>Please use outer width as the blinds are outside mounted.For the drop size, 
                 usually it is the outside drop plus the distance to the floor (floor curtain). 
                 Otherwise use outside drop  plus extra 20cm if you want to hang the curtain and cover just the window.</h3>
                    <img src="../assets/cusMade-width.png" alt="" style="width:400px;height:500px">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
              </el-col>
              <el-col :lg="2" :md="2">Drop(cm)</el-col>
              <el-col :lg="2" :md="2">Fabric
                <el-popover placement="top-start"  width="500" trigger="hover">
                    <table cellpadding="8px">
                        <th style="width:50px">Type</th>
                        <th style="width:100px">Price</th>
                        <th style="width:150px">Range</th>                       
                        <th style="width:50px">Sample Picture</th>                        
                        <tr>
                            <td>Plain</td>
                            <td>$45/m width (up to 270cm drop)</td>
                            <td>dozens of choices in store.</td>                            
                            <td><a href="https://api.ifurniture.co.nz/image/sliding-curtain-track.jpeg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/sliding-curtain-track.jpeg"></a></td>                                                      
                        </tr>
                        <tr>
                            <td>Pattern</td>
                            <td>$55/m width (up to 270cm drop)</td>
                            <td>dozens of choices in store.</td>                              
                             <td><a href="https://api.ifurniture.co.nz/image/eyelet-curtain-track.jpeg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/eyelet-curtain-track.jpeg"></a></td>                                                      
                        </tr>
                         <tr>
                            <td>Complex Pattern</td>
                            <td>$65/m width (up to 270cm drop)</td>
                            <td>dozens of choices in store.</td>                              
                             <td><a href="https://api.ifurniture.co.nz/image/eyelet-curtain-track.jpeg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/eyelet-curtain-track.jpeg"></a></td>                                                      
                        </tr>
                    </table>                    
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
            </el-col>
            <el-col :lg="2" :md="2">Lining
                <el-popover placement="top-start"  width="500" trigger="hover">
                    <table cellpadding="8px">                                         
                        <tr>
                            <td>It has a 'solprufe' coating which prevents fading and sun damage(Special in NZ). 
                  This lining will improve the drape of your curtains, creating a more substantial, fuller look. 
                  2. ... Blackout lining also has thermal qualities, helping to prevent draughts and minimizing the loss of heat, 
                  in the same way that thermal lining works.</td>                                                  
                            <td><a href="https://api.ifurniture.co.nz/image/pencil pleat.jpg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/pencil pleat.jpg"></a></td>                                                      
                        </tr>                        
                    </table>                    
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>                  
            </el-col>
            <el-col :lg="2" :md="2">Sheer
                 <el-popover placement="top-start"  width="500" trigger="hover">
                    <table cellpadding="8px">                                         
                        <tr>
                            <td>A sheer/netting curtain is the type that allows the most light through the fabric, 
                  which also means it offers the least privacy. If held up to your face, it's possible to see completely 
                  through the fabric. Sheer curtains are sometimes paired with opaque drapes for a more formal look, 
                  as well as additional privacy after dark.</td>                                                  
                            <td><a href="https://api.ifurniture.co.nz/image/pencil pleat.jpg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/pencil pleat.jpg"></a></td>                                                      
                        </tr>                        
                    </table>                    
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>  
                 
            </el-col>
            <el-col :lg="2" :md="2">Price</el-col>
             <el-col :lg="1" :md="1">Saved</el-col>
            <el-col :lg="1" :md="1">Operation</el-col>
        </el-row>
        <el-row v-for="(customerMadeCurtain,index) in customerMadeCurtains" :key="index" class="rowpadding hidden-sm-and-down">
         
            <el-form :rules="rulesNumber" :model="customerMadeCurtain">
            <el-col :lg="1" :md="1" :offset="2" class="colpadding">{{index+1}}</el-col>
            <el-col :lg="3" :md="3" class="colpadding">
                <el-input v-model="customerMadeCurtain.Window"  @input="inputChange(index)"></el-input>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding">
                 <el-select v-model="customerMadeCurtain.Type" placeholder="Type" value-key="cusCurtainType" @change="addCurtain(index)">
                 <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding">
                <el-form-item  prop="Width">
                 <el-input v-model="customerMadeCurtain.Width"  @input="inputChange(index)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding">
                <el-form-item  prop="Drop">
                <el-input v-model="customerMadeCurtain.Drop"  @input="inputChange(index)"></el-input>
                </el-form-item>
            </el-col>
         
            <el-col :lg="2" :md="2" class="colpadding" >
                 <el-select v-model="customerMadeCurtain.Fabric" placeholder="Fabric" v-show="customerMadeCurtain.Drop<=270" value-key="cusCurtainFabric" @change="addCurtain(index)">
                 <el-option v-for="item in fabricOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding" >
                 <el-select v-model="customerMadeCurtain.Lining" placeholder="Lining" v-show="customerMadeCurtain.Drop<=270" value-key="cusCurtainLining" @change="addCurtain(index)">
                 <el-option v-for="item in liningOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding" >
                 <el-select v-model="customerMadeCurtain.Sheer" placeholder="Sheer" v-show="customerMadeCurtain.Drop<=270" value-key="cusCurtainSheer" @change="addCurtain(index)">
                 <el-option v-for="item in sheerOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
            </el-col>
           
            <el-col :lg="2" :md="2" class="colpadding alignLeft">
             
                    <el-tag v-if="customerMadeCurtain.Drop>270" type="warning">please contact us</el-tag>
                    <div class="alignLeft priceStyle" v-else>${{customerMadeCurtain.Price}}</div>
                     <!-- <el-tag type="success" v-else-if="customerMadeCurtain.Price>0">{{customerMadeCurtain.Price}}</el-tag> -->
                <!-- <el-tag type="warning" v-else>{{customerMadeCurtain.Price}}</el-tag> -->
            </el-col>
             <el-col :lg="1" :md="1" class="colpadding">
                <i :class="customerMadeCurtain.Saved"></i>
            </el-col>
            <el-col :lg="1" :md="1" class="colpadding">
                
              <el-button type="danger" @click="removeCurtain(customerMadeCurtain)">Delete</el-button>
            </el-col>
             </el-form>
             <el-row class="alignLeft" style="margin-left:10%;color:red;position:absolute;bottom:0" v-show="customerMadeCurtain.Drop>270">
               Any curtain with a drop over 270cm is special, please contact us for detailed design and cost. 
            </el-row>
    </el-row>
       
          <el-row class="rowpadding hidden-sm-and-down alignLeft" style="margin-left:10%">
            <el-button type="success" @click="addNewCurtain">Add a Custom Made Curtain</el-button>
        </el-row>
        <div class="hidden-md-and-up">
        <el-card class="box-card" v-for="(customerMadeCurtain,index) in customerMadeCurtains" :key="index" >
             <el-form :rules="rulesNumber" :model="customerMadeCurtain">
         <div slot="header" class="clearfix">
          <span>No.{{index+1}}</span>
          <el-button style="float: right; padding: 3px 0" type="success" @click="addNewCurtain">Add</el-button>
         </div>
         <div style="text-align:left">
             <el-row style="color:red" v-show="customerMadeCurtain.Drop>270">
                   Any curtain with a drop over 270cm is special, please contact us for detailed design and cost.
             </el-row>
             <el-row class="rowpadding">
             <el-col :sm="6" :xs="6" style=" word-wrap:break-word; ">Reference</el-col>
              <el-col :sm="16" :xs="16"><el-input v-model="customerMadeCurtain.Window"  @input="inputChange(index)"></el-input></el-col>
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">
                    Type
                 <el-popover placement="top-start" width="310" trigger="click">
                     <ul>
                         <li>
                             <h3>Sliding Track (Double pleat)</h3>
                             <p>Pinch pleat curtains are a decorative heading for curtains 
                                 and valances and can be used on all curtain tracks and poles. 
                                 Pinch pleat heading is more gathered than other curtain headings 
                                 with the pleats sewn in to give a luxurious and permanent gathered look. </p>
                         </li>
                         <li>
                             <h3>Eyelet curtains or Ring Top curtains </h3>
                             <p>heading for use with curtain poles. Eyelet heading gives large even soft pleats 
                                 and are so called because they have metal rings at the top of the curtain in place 
                                 of a normal header tape.</p>
                         </li>
                     </ul>
                  <div class="el-icon-info" slot="reference" style="color:green"></div>
                 </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16">
                     <el-select v-model="customerMadeCurtain.Type" placeholder="Type" value-key="cusCurtainTypem" @change="addCurtain(index)">
                 <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
                </el-col>
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">Width(cm)
                  <el-popover placement="top-start" title="About Width" 
               width="300" trigger="click">
                    <h3>Please use outer width as the blinds are outside mounted.For the drop size, 
                 usually it is the outside drop plus the distance to the floor (floor curtain). 
                 Otherwise use outside drop  plus extra 20cm if you want to hang the curtain and cover just the window.</h3>
                    <img src="../assets/cusMade-width.png" alt="" style="width:200px;height:300px">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16"> 
                    <el-form-item  prop="Width" style="margin:0">
                    <el-input v-model="customerMadeCurtain.Width"  @input="inputChange(index)"></el-input>
                    </el-form-item>
                </el-col> 
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">Drop(cm)</el-col>
                <el-col :sm="16" :xs="16"> 
                    <el-form-item  prop="Drop" style="margin:0">
                    <el-input v-model="customerMadeCurtain.Drop"  @input="inputChange(index)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            
             <el-row v-show="customerMadeCurtain.Drop<=270" class="rowpadding">
                <el-col :sm="6" :xs="6">Fabric
                      <el-popover placement="top-start"  width="200" trigger="click">
                    <ul>
                        <li>Plain fabric $45/m</li>
                        <li>Pattern fabric $55/m</li>
                        <li>Others on require</li>
                    </ul>
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16">
                     <el-select v-model="customerMadeCurtain.Fabric" placeholder="Fabric" value-key="cusCurtainFabricm" @change="addCurtain(index)">
                 <el-option v-for="item in fabricOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
                </el-col>
            </el-row >
             <el-row v-show="customerMadeCurtain.Drop<=270" class="rowpadding">
                <el-col :sm="6" :xs="6">Lining
                    <el-popover placement="top-start" title="Curtain Lining" width="200" trigger="click"
                  content="It has a 'solprufe' coating which prevents fading and sun damage(Special in NZ). 
                  This lining will improve the drape of your curtains, creating a more substantial, fuller look. 
                  2. ... Blackout lining also has thermal qualities, helping to prevent draughts and minimizing the loss of heat, 
                  in the same way that thermal lining works.">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16">
                     <el-select v-model="customerMadeCurtain.Lining" placeholder="Lining" value-key="cusCurtainLiningm" @change="addCurtain(index)">
                 <el-option v-for="item in liningOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
                </el-col>
             </el-row>
            <el-row v-show="customerMadeCurtain.Drop<=270" class="rowpadding">
                <el-col :sm="6" :xs="6">Sheer
                      <el-popover placement="top-start" title="Sheer/netting curtain" width="200" trigger="click"
                  content="A sheer/netting curtain is the type that allows the most light through the fabric, 
                  which also means it offers the least privacy. If held up to your face, it's possible to see completely 
                  through the fabric. Sheer curtains are sometimes paired with opaque drapes for a more formal look, 
                  as well as additional privacy after dark">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover> 
                </el-col>
                <el-col :sm="16" :xs="16">
                     <el-select v-model="customerMadeCurtain.Sheer" placeholder="Sheer" value-key="cusCurtainSheerm" @change="addCurtain(index)">
                 <el-option v-for="item in sheerOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
                </el-col>
             </el-row>
         </div>
         <hr>
         <div v-if="customerMadeCurtain.Drop>270"> Price:
         <el-tag  type="warning">Please contact us</el-tag>
         Saved:
         <i :class="customerMadeCurtain.Saved"></i>
          <el-button style="float: right; padding: 3px 0" type="danger" @click="removeCurtain(customerMadeCurtain)">Delete</el-button>
        </div>
         <div v-else>Price:
           <span class="info priceStyle">${{customerMadeCurtain.Price}}</span>
              <!-- <el-tag type="success" v-if="customerMadeCurtain.Price>0">{{customerMadeCurtain.Price}}</el-tag>
                <el-tag type="warning" v-else>{{customerMadeCurtain.Price}}</el-tag> -->
             Saved:
           <i :class="customerMadeCurtain.Saved"></i>
             <el-button style="float: right; padding: 3px 0" type="danger" @click="removeCurtain(customerMadeCurtain)">Delete</el-button>
         </div>
        </el-form>
        </el-card>
       </div> 
    </div>
</template>
<script>
import { loadDataFromFile } from "@/api/LoadDataFromFile";
import { addCurtain } from "@/api/AddCurtain";
import { deleteCurtain } from "@/api/DeleteCurtain";
import _ from "lodash";
export default {
  name: "CusMadeCurtains",
  props: ["cusMadeCurtains", "options"],

  data() {
    var checkNum = (rule, value, callback) => {
      if (isNaN(value)) {
        return callback(new Error("valid from 1 to 1000"));
      } else if (value < 1 || value > 1000) {
        return callback(new Error("valid from 1 to 1000"));
      } else {
        callback();
      }
    };
    return {
      customerMadeCurtains: this.cusMadeCurtains,
      allOptions: [],
      typeOptions: [],
      fabricOptions: [],
      liningOptions: [],
      sheerOptions: [],
      rulesNumber: {
        Width: [{ validator: checkNum, trigger: ["blur", "change"] }],
        Drop: [{ validator: checkNum, trigger: ["blur", "change"] }]
      }
    };
  },
  watch: {
    options: {
      deep: true,
      handler(nv, ov) {
        this.allOptions = nv;
        this.getOprtions();
      }
    }
  },
  methods: {
    addNewCurtain() {
      const newCurtain = {
        CurtainId: "",
        Window: "",
        Type: "",
        Drop: null,
        Width: null,
        Fabric: "",
        Lining: "",
        Sheer: "",
        Price: 0,
        Saved: "el-icon-close"
      };

      this.customerMadeCurtains.push(newCurtain);
      //  window.scrollTo(0,document.body.scrollHeight);
    },
    removeCurtain(item) {
      var index = this.customerMadeCurtains.indexOf(item);
      if (index !== -1) {
        if (this.customerMadeCurtains[index].CurtainId !== "") {
          deleteCurtain(this.customerMadeCurtains[index].CurtainId)
            .then(res => {
              if (res.data.Success) {
                this.$store.commit("changeCurtain");
              }
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        }
        this.customerMadeCurtains.splice(index, 1);
      }
    },
    getOprtions() {
      this.allOptions.forEach(item => {
        if (item.modelName === "Custom Made Curtains") {
          this.typeOptions = item.TrackTypes;
          this.fabricOptions = item.Fabrics;
          this.liningOptions = item.Linings;
          this.sheerOptions = item.Sheers;
        }
      });
    },
    addCurtain(index) {
      if (
        this.customerMadeCurtains[index].Type !== "" &&
        !isNaN(this.customerMadeCurtains[index].Drop) &&
        this.customerMadeCurtains[index].Drop > 0 &&
        this.customerMadeCurtains[index].Drop <= 270 &&
        !isNaN(this.customerMadeCurtains[index].Width) &&
        this.customerMadeCurtains[index].Width > 0 &&
        this.customerMadeCurtains[index].Width <= 1000 &&
        this.customerMadeCurtains[index].Fabric !== "" &&
        this.customerMadeCurtains[index].Lining !== "" &&
        this.customerMadeCurtains[index].Sheer !== ""
      ) {
        const CurtainQuoationId = localStorage.getItem("curtain_quoationId");
        const CurtainCustomerId = localStorage.getItem("curtain_customerId");
        const newCurtain = {};
        newCurtain.CurtainId = this.customerMadeCurtains[index].CurtainId;
        newCurtain.RoomName = this.customerMadeCurtains[index].Window;
        newCurtain.CurtainDrop = this.customerMadeCurtains[index].Drop;
        newCurtain.CurtainWidth = this.customerMadeCurtains[index].Width;
        newCurtain.FabricType = this.customerMadeCurtains[index].Fabric;
        newCurtain.TrackType = this.customerMadeCurtains[index].Type;
        newCurtain.Lining = this.customerMadeCurtains[index].Lining;
        newCurtain.Sheer = this.customerMadeCurtains[index].Sheer;
        newCurtain.Price = this.customerMadeCurtains[index].Price;
        newCurtain.ModelName = "Custom Made Curtains";
        this.$nextTick(() => {
          addCurtain(CurtainQuoationId, CurtainCustomerId, newCurtain)
            .then(res => {
              this.customerMadeCurtains[index].Price = res.data.CPrice.toFixed(
                2
              );
              this.customerMadeCurtains[index].CurtainId = res.data.CurtainId;
              this.customerMadeCurtains[index].Saved =
                "el-icon-check dataSaved";
              this.$store.commit("changeCurtain");
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        });
      } else {
        this.customerMadeCurtains[index].Saved = "el-icon-close";
        if (this.customerMadeCurtains[index].CurtainId !== "") {
          deleteCurtain(this.customerMadeCurtains[index].CurtainId)
            .then(res => {
              if (res.data.Success) {
                this.customerMadeCurtains[index].CurtainId = "";
                this.customerMadeCurtains[index].Price = 0;
                this.$store.commit("changeCurtain");
              }
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        }
      }
    },
    inputChange: _.debounce(function(index) {
      this.addCurtain(index);
    }, 500)
  }
};
</script>
<style>
.box-card {
  margin: 10px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.rowpadding {
  padding: 5px;
}
.colpadding {
  padding: 3px;
}
.dataSaved {
  background-color: green;
  color: white;
  font-weight: 400;
}
.alignleftTitle {
  text-align: left;
  margin-left: 10%;
}
.alignLeft {
  text-align: left;
}
.alignCenter {
  text-align: center;
}
.priceStyle {
  margin-top: 10px;
  font-weight: bold;
  color: #0066cc;
}
</style>



// WEBPACK FOOTER //
// src/components/CusMadeCurtains.vue